<template>
	<div class="pay-record-container">
		<div class="search-box">
			<date-picker
				v-model="dateTime"
				:value="[]"
				:start_placeholder="pageText.starttime"
				:end_placeholder="pageText.endtime"></date-picker>
			<mobile-button class="btn-search" color="#005423" @click="onSearch">
				<van-icon name="search" />
				<span>{{ pageText.search }}</span>
			</mobile-button>
		</div>
		<div class="content">
			<div v-if="!loading && !$utils.isEmpty(recordList)">
				<div class="card-wrapper" v-for="(item, index) in recordList" :key="index">
					<mobile-card :show-title="false">
						<template slot="content">
							<div class="flex-form-info">
								<span>{{ pageText.code }}</span>
								<!-- <span>{{item.outPayNo}}</span> -->
								<span>{{ item.orderNo }}</span>
							</div>

							<div class="flex-form-info">
								<span>{{ pageText.money }}</span>
								<span class="money-item">{{ item.money | formatMoney }}</span>
							</div>

							<div class="flex-form-info">
								<span>{{ pageText.pay_type }}</span>
								<span>{{ item.payTypeName }}</span>
							</div>

							<div class="flex-form-info">
								<span>{{ pageText.pay_date }}</span>
								<span>{{ item.payTime }}</span>
							</div>

							<div class="flex-form-info">
								<span>{{ pageText.operate }}</span>
								<span class="operate-item" @click="onCheckDetail(item)">{{ pageText.detail }}</span>
							</div>
						</template>
					</mobile-card>
				</div>
			</div>

			<van-overlay :show="loading" @click="loading = false">
				<div style="display: flex; align-items: center; justify-content: center; height: 100%" @click.stop>
					<van-loading vertical>{{ pageText.loading }}</van-loading>
				</div>
			</van-overlay>

			<div v-if="$utils.isEmpty(recordList) && !loading" class="empty-block">
				<span>{{ emptyText }}</span>
			</div>
		</div>

		<div class="footer">
			<div class="footer-bar">
				<van-button color="#005423" block @click="onBack">{{ pageText.pre_page }}</van-button>
			</div>
		</div>
	</div>
</template>

<script>
import log from 'utils/log'
import datePicker from 'components/date-picker/index'
import MobileCard from 'components/mobile-card/index'
import apiPayRecord from 'api/pay-record'
// import {setState} from "utils/state";
import storage from 'good-storage'
import MobileButton from 'components/mobile-button/index'
import utils from '@/utils/util'
import moment from 'moment'
import { Overlay } from 'vant'

export default {
	name: 'payRecord',
	components: {
		MobileButton,
		MobileCard,
		datePicker
	},

	data() {
		return {
			recordList: [],
			// dateTime: [],
			dateTime: [],
			defaultTime: ['00:00:00', '23:59:59'],
			emptyText: this.$t('pay_situation.emptyText'),
			loading: false,
			pageText: {
				loading: this.$t('pay_situation.loading'),
				pre_page: this.$t('pay_situation.pre_page'),
				starttime: this.$t('pay_record.list.starttime'),
				endtime: this.$t('pay_record.list.endtime'),
				search: this.$t('pay_record.list.search'),
				code: this.$t('pay_record.list.code'),
				money: this.$t('pay_record.list.money'),
				pay_type: this.$t('pay_record.list.pay_type'),
				pay_date: this.$t('pay_record.list.pay_date'),
				operate: this.$t('pay_record.list.operate'),
				detail: this.$t('pay_record.list.detail')
			}
		}
	},

	activated() {
		this.onSearch()
	},

	methods: {
		onSearch() {
			log('search begin')
			let self = this
			log('this.dateTime', this.dateTime)
			let param = {
				startTime: '',
				endTime: ''
			}

			if (utils.isNotEmpty(this.dateTime[0])) {
				param.startTime = `${this.dateTime[0]} ${this.defaultTime[0]}`
			}

			if (utils.isNotEmpty(this.dateTime[1])) {
				param.endTime = `${this.dateTime[1]} ${this.defaultTime[1]}`
			}
			self.loading = true
			self.recordList = []
			apiPayRecord
				.list(param)
				.then(res => {
					log('res is ', res.data)
					self.loading = false
					self.recordList = res.data || []
				})
				.catch(err => {
					self.loading = false
				})
		},

		onCheckDetail(item) {
			log('check item is', item)
			// setState('select-record', item)
			storage.session.set('select-record', item)
			this.$router.push({
				path: 'pay-record-detail'
			})
		},

		onBack() {
			this.$router.back()
		}
	}
}
</script>

<style lang="scss" scoped></style>
